import React from 'react'
import {
  TranscriptFormCard,
  TranscriptFormCardVariant,
} from './TranscriptFormCard'
import { Page } from '../Elements/PageMargins'
import { useTranscriptContext } from '../Context/TranscriptContext'
import { useFetchTranscript } from '@hooks/useFetchTranscript'
import { useUnmountEffect } from '@hooks/useUnmountEffect'
import { useParams } from 'react-router-dom'
import { useMountEffect } from '@hooks/useMountEffect'
import { useAuth } from '../Routes/AuthProvider'
import { CanAccess } from '../Elements/Access'
import LoadingProgress from '../Elements/LoadingProgress'
import TitleContext from '../../TitleContext'
import { useTranslation } from 'react-i18next'

export const TranscriptDetails: React.FC = () => {
  const {
    updateSelectedTranscriptKey,
    selectedTranscriptKey,
    resetContextToDefaults,
  } = useTranscriptContext()
  const { transcriptKey } = useParams<{ transcriptKey: string }>()
  const { userDetails } = useAuth()
  const { isLoading } = useFetchTranscript({
    transcriptKey: selectedTranscriptKey,
  })
  const { t } = useTranslation()
  const { useTitleEffect } = React.useContext(TitleContext)
  useTitleEffect(t('Transcripts.TranscriptDetails.Title', 'Transcripts'))

  useMountEffect(() => {
    const transcriptKeyNumber = Number(transcriptKey)
    if (!isNaN(transcriptKeyNumber)) {
      updateSelectedTranscriptKey(transcriptKeyNumber)
    }
  })

  useUnmountEffect(() => {
    resetContextToDefaults()
  })

  if (isLoading) {
    return <LoadingProgress />
  }

  return (
    <Page>
      {userDetails.actingAs === 'parent' ? (
        <TranscriptFormCard variant={TranscriptFormCardVariant.Edit} />
      ) : (
        /** If they can print, for now, they can view a transcript to print only that transcript. */
        <CanAccess I="print" on="Transcript">
          <TranscriptFormCard variant={TranscriptFormCardVariant.Edit} />
        </CanAccess>
      )}
    </Page>
  )
}

export default TranscriptDetails
